import { useDataScope, useFarmName } from '../utils/hooks';

interface CropExportFileNameProps {
  cropName: Nullable<string>;
  plural: boolean;
  title: string;
}

const useCropExportFileName = ({
  cropName,
  plural = true,
  title,
}: CropExportFileNameProps) => {
  const scope = useDataScope();
  const farmName = useFarmName(scope !== 'farm');
  return [
    `${cropName} ${title}${scope === 'farm' ? '' : ' Template'}${
      plural ? 's' : ''
    }`,
    farmName,
  ]
    .filter((v) => v)
    .join(' - ');
};

export default useCropExportFileName;
